<div *ngIf="mail2SmsPostmaster">
  <div class="stick-top">
    <mat-toolbar>
      <mat-icon>email</mat-icon> {{!mail2SmsPostmaster.id ? 'Create new Email2Msg Postmaster' : ('Email2Msg Postmaster ' + mail2SmsPostmaster.name)}}
    </mat-toolbar>
    <div class="hbox lightly-padded button-bar">
      <button mat-raised-button class="primary" type="button" (click)="save()" [disabled]="!form.form.valid">
        <mat-icon>{{!mail2SmsPostmaster.id ? 'add' : 'save'}}</mat-icon>
        {{(mail2SmsPostmaster.id ? 'Update ' : 'Add ')}}
      </button>
      <micro-delete-confirm *ngIf="mail2SmsPostmaster.id" (onConfirm)="delete()"></micro-delete-confirm>
    </div>
  </div>

  <div class="padded vbox-space">
    <div>
      <form #form="ngForm" role="form" class="vbox">
        <table class="basicTable vtable">
          <thead>
          <tr>
            <th colspan="100">Mail2Msg Postmaster Configuration</th>
          </tr>
          </thead>
          <tbody>

          <tr>
            <th><micro-valid-label for="name" [model]="name" label="Name"></micro-valid-label></th>
            <td>
              <input #name="ngModel" [(ngModel)]="mail2SmsPostmaster.name" required placeholder="Name" id="name" name="name">
            </td>
          </tr>
          <tr>
            <th>Incoming Mailbox</th>
            <td>
              <micro-imap-select [(imapId)]="mail2SmsPostmaster.imapMailboxId" required="true"></micro-imap-select>
            </td>
          </tr>
          <tr>
            <th>Outgoing Mailbox</th>
            <td>
              <micro-smtp-select [(smtpId)]="mail2SmsPostmaster.smtpMailboxId" required="true"></micro-smtp-select>
            </td>
          </tr>
          <tr>
            <th><micro-valid-label for="enabled" [model]="enabled" label="Enabled"></micro-valid-label></th>
            <td>
              <input type="checkbox" #enabled="ngModel" [(ngModel)]="mail2SmsPostmaster.enabled" placeholder="Enabled" id="enabled" name="enabled">
            </td>
          </tr>
          <tr *ngIf="mail2SmsPostmaster.id">
            <th>Incoming Mailbox Queueing Strategy</th>
            <td>
              <span *ngIf="mail2SmsPostmaster.incomingQueueingStrategy.toUpperCase().includes('DIRECT')"><mat-icon class="icon-small" style="color: green">check_circle</mat-icon></span>
              <span *ngIf="!mail2SmsPostmaster.incomingQueueingStrategy.toUpperCase().includes('DIRECT')"><mat-icon  class="icon-small" style="color: red">cancel</mat-icon></span>
              &nbsp;{{mail2SmsPostmaster.incomingQueueingStrategy}}

            </td>
          </tr>

          </tbody>
        </table>
      </form>
    </div>
  </div>
</div>
